import type { ErrorType } from '../../shared/lib/axios/client'
import type {
  PreferenceControllerDeleteOrgPreferenceParams,
  PreferenceControllerDeleteUserPreferenceParams,
  PreferenceControllerFind200Item,
  PreferenceControllerFindParams,
  PreferenceControllerUpsertOrgPreferenceBody,
  PreferenceControllerUpsertUserPreferenceBody,
  PreferenceDto,
} from '.././types'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Detelio API specification
 * openAPI specification for Detelio API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'

import { axiosClient } from '../../shared/lib/axios/client'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const preferenceControllerFind = (
  params?: PreferenceControllerFindParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PreferenceControllerFind200Item[]>(
    { url: `https://test-api.detelio.ai/preference`, method: 'GET', params, signal },
    options,
  )
}

export const getPreferenceControllerFindQueryKey = (params?: PreferenceControllerFindParams) => {
  return [`https://test-api.detelio.ai/preference`, ...(params ? [params] : [])] as const
}

export const getPreferenceControllerFindQueryOptions = <
  TData = Awaited<ReturnType<typeof preferenceControllerFind>>,
  TError = ErrorType<unknown>,
>(
  params?: PreferenceControllerFindParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof preferenceControllerFind>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getPreferenceControllerFindQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof preferenceControllerFind>>> = ({ signal }) =>
    preferenceControllerFind(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof preferenceControllerFind>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreferenceControllerFindQueryResult = NonNullable<
  Awaited<ReturnType<typeof preferenceControllerFind>>
>
export type PreferenceControllerFindQueryError = ErrorType<unknown>

export function usePreferenceControllerFind<
  TData = Awaited<ReturnType<typeof preferenceControllerFind>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | PreferenceControllerFindParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof preferenceControllerFind>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof preferenceControllerFind>>,
          TError,
          Awaited<ReturnType<typeof preferenceControllerFind>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreferenceControllerFind<
  TData = Awaited<ReturnType<typeof preferenceControllerFind>>,
  TError = ErrorType<unknown>,
>(
  params?: PreferenceControllerFindParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof preferenceControllerFind>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof preferenceControllerFind>>,
          TError,
          Awaited<ReturnType<typeof preferenceControllerFind>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreferenceControllerFind<
  TData = Awaited<ReturnType<typeof preferenceControllerFind>>,
  TError = ErrorType<unknown>,
>(
  params?: PreferenceControllerFindParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof preferenceControllerFind>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePreferenceControllerFind<
  TData = Awaited<ReturnType<typeof preferenceControllerFind>>,
  TError = ErrorType<unknown>,
>(
  params?: PreferenceControllerFindParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof preferenceControllerFind>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPreferenceControllerFindQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const preferenceControllerUpsertUserPreference = (
  preferenceControllerUpsertUserPreferenceBody: PreferenceControllerUpsertUserPreferenceBody,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<PreferenceDto>(
    {
      url: `https://test-api.detelio.ai/preference`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: preferenceControllerUpsertUserPreferenceBody,
    },
    options,
  )
}

export const getPreferenceControllerUpsertUserPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof preferenceControllerUpsertUserPreference>>,
    TError,
    { data: PreferenceControllerUpsertUserPreferenceBody },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof preferenceControllerUpsertUserPreference>>,
  TError,
  { data: PreferenceControllerUpsertUserPreferenceBody },
  TContext
> => {
  const mutationKey = ['preferenceControllerUpsertUserPreference']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof preferenceControllerUpsertUserPreference>>,
    { data: PreferenceControllerUpsertUserPreferenceBody }
  > = (props) => {
    const { data } = props ?? {}

    return preferenceControllerUpsertUserPreference(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PreferenceControllerUpsertUserPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof preferenceControllerUpsertUserPreference>>
>
export type PreferenceControllerUpsertUserPreferenceMutationBody =
  PreferenceControllerUpsertUserPreferenceBody
export type PreferenceControllerUpsertUserPreferenceMutationError = ErrorType<unknown>

export const usePreferenceControllerUpsertUserPreference = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof preferenceControllerUpsertUserPreference>>,
      TError,
      { data: PreferenceControllerUpsertUserPreferenceBody },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof preferenceControllerUpsertUserPreference>>,
  TError,
  { data: PreferenceControllerUpsertUserPreferenceBody },
  TContext
> => {
  const mutationOptions = getPreferenceControllerUpsertUserPreferenceMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const preferenceControllerDeleteUserPreference = (
  params: PreferenceControllerDeleteUserPreferenceParams,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/preference`, method: 'DELETE', params },
    options,
  )
}

export const getPreferenceControllerDeleteUserPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof preferenceControllerDeleteUserPreference>>,
    TError,
    { params: PreferenceControllerDeleteUserPreferenceParams },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof preferenceControllerDeleteUserPreference>>,
  TError,
  { params: PreferenceControllerDeleteUserPreferenceParams },
  TContext
> => {
  const mutationKey = ['preferenceControllerDeleteUserPreference']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof preferenceControllerDeleteUserPreference>>,
    { params: PreferenceControllerDeleteUserPreferenceParams }
  > = (props) => {
    const { params } = props ?? {}

    return preferenceControllerDeleteUserPreference(params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PreferenceControllerDeleteUserPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof preferenceControllerDeleteUserPreference>>
>

export type PreferenceControllerDeleteUserPreferenceMutationError = ErrorType<unknown>

export const usePreferenceControllerDeleteUserPreference = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof preferenceControllerDeleteUserPreference>>,
      TError,
      { params: PreferenceControllerDeleteUserPreferenceParams },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof preferenceControllerDeleteUserPreference>>,
  TError,
  { params: PreferenceControllerDeleteUserPreferenceParams },
  TContext
> => {
  const mutationOptions = getPreferenceControllerDeleteUserPreferenceMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const preferenceControllerUpsertOrgPreference = (
  preferenceControllerUpsertOrgPreferenceBody: PreferenceControllerUpsertOrgPreferenceBody,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<PreferenceDto>(
    {
      url: `https://test-api.detelio.ai/preference/org`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: preferenceControllerUpsertOrgPreferenceBody,
    },
    options,
  )
}

export const getPreferenceControllerUpsertOrgPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof preferenceControllerUpsertOrgPreference>>,
    TError,
    { data: PreferenceControllerUpsertOrgPreferenceBody },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof preferenceControllerUpsertOrgPreference>>,
  TError,
  { data: PreferenceControllerUpsertOrgPreferenceBody },
  TContext
> => {
  const mutationKey = ['preferenceControllerUpsertOrgPreference']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof preferenceControllerUpsertOrgPreference>>,
    { data: PreferenceControllerUpsertOrgPreferenceBody }
  > = (props) => {
    const { data } = props ?? {}

    return preferenceControllerUpsertOrgPreference(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PreferenceControllerUpsertOrgPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof preferenceControllerUpsertOrgPreference>>
>
export type PreferenceControllerUpsertOrgPreferenceMutationBody = PreferenceControllerUpsertOrgPreferenceBody
export type PreferenceControllerUpsertOrgPreferenceMutationError = ErrorType<unknown>

export const usePreferenceControllerUpsertOrgPreference = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof preferenceControllerUpsertOrgPreference>>,
      TError,
      { data: PreferenceControllerUpsertOrgPreferenceBody },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof preferenceControllerUpsertOrgPreference>>,
  TError,
  { data: PreferenceControllerUpsertOrgPreferenceBody },
  TContext
> => {
  const mutationOptions = getPreferenceControllerUpsertOrgPreferenceMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const preferenceControllerDeleteOrgPreference = (
  params: PreferenceControllerDeleteOrgPreferenceParams,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/preference/org`, method: 'DELETE', params },
    options,
  )
}

export const getPreferenceControllerDeleteOrgPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof preferenceControllerDeleteOrgPreference>>,
    TError,
    { params: PreferenceControllerDeleteOrgPreferenceParams },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof preferenceControllerDeleteOrgPreference>>,
  TError,
  { params: PreferenceControllerDeleteOrgPreferenceParams },
  TContext
> => {
  const mutationKey = ['preferenceControllerDeleteOrgPreference']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof preferenceControllerDeleteOrgPreference>>,
    { params: PreferenceControllerDeleteOrgPreferenceParams }
  > = (props) => {
    const { params } = props ?? {}

    return preferenceControllerDeleteOrgPreference(params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PreferenceControllerDeleteOrgPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof preferenceControllerDeleteOrgPreference>>
>

export type PreferenceControllerDeleteOrgPreferenceMutationError = ErrorType<unknown>

export const usePreferenceControllerDeleteOrgPreference = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof preferenceControllerDeleteOrgPreference>>,
      TError,
      { params: PreferenceControllerDeleteOrgPreferenceParams },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof preferenceControllerDeleteOrgPreference>>,
  TError,
  { params: PreferenceControllerDeleteOrgPreferenceParams },
  TContext
> => {
  const mutationOptions = getPreferenceControllerDeleteOrgPreferenceMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
